var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemReturn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19.5 5.23v7.385H6.266l2.867-2.822a1.216 1.216 0 0 0 0-1.74 1.263 1.263 0 0 0-1.768 0l-4.999 4.922a1.22 1.22 0 0 0-.271 1.341q.096.23.271.402l5 4.921c.243.24.563.361.883.361s.64-.12.884-.36a1.216 1.216 0 0 0 0-1.74l-2.867-2.823H20.75c.691 0 1.25-.55 1.25-1.23V5.23C22 4.55 21.441 4 20.75 4s-1.25.55-1.25 1.23"
})));
export default SvgGemReturn;